import React from 'react';
import { motion } from 'framer-motion';
import {
  CheckCircle as CheckCircleIcon,
  RadioButtonUnchecked as UncheckedIcon
} from '@mui/icons-material';
import '../../../assets/scss/components/qr/AttendanceStepper.scss';

const AttendanceStepper = ({ currentStep, steps, isExit = false }) => {
  const getStepIndex = (stepId) => {
    return steps.findIndex(step => step.id === stepId);
  };

  const currentIndex = getStepIndex(currentStep);

  return (
    <div className="attendance-stepper">
      <div className="stepper-content">
        <div className="worker-illustration">
        </div>

        <nav className="stepper-nav">
          {steps.map((step, index) => {
            const isActive = index === currentIndex;
            const isCompleted = index < currentIndex;
            const isVisible = step.condition ? step.condition() : true;

            if (!isVisible) return null;

            return (
              <motion.div
                key={step.id}
                className={`stepper-item ${isActive ? 'active' : ''} ${isCompleted ? 'completed' : ''}`}
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: index * 0.1 }}
              >
                <div className="step-indicator">
                  <span className="step-number">{index + 1}</span>
                  <div className="step-icon">
                    {isCompleted ? (
                      <CheckCircleIcon className="check-icon" />
                    ) : (
                      <UncheckedIcon className="unchecked-icon" />
                    )}
                  </div>
                </div>
                
                <div className="step-content">
                  <h4 className="step-title">{step.title}</h4>
                  {isActive && step.description && (
                    <p className="step-description">{step.description}</p>
                  )}
                </div>
                
                {index < steps.length - 1 && (
                  <div className="step-connector" />
                )}
              </motion.div>
            );
          })}
        </nav>
      </div>
    </div>
  );
};

export default AttendanceStepper;